var logs = new Logs();
var charts = new Charts();
var dtTable = new DtTables();
var objSelected = []
var arrSelected = []
const momentDuration = require('moment-duration-format');
momentDuration(moment);

$(function () {

    var clients = [];
    var operators = [];
    var firstOfTheMonth = moment().format('YYYY-MM-01T00:00')
    var now = moment().format('YYYY-MM-DDTHH:mm')
    var element = document.getElementById('inputSelectType');
    var searchClients = document.getElementById('input-searchClients');
    var searchOperators = document.getElementById('input-searchTechs');

    $('.select-dropdown').remove();
    $('.caret').remove();
    $('select[name="datatables_length"]').addClass('browser-default');

    $('#inputDataInicio').val(firstOfTheMonth);
    $('#inputDataFim').val(now);
    $('#inputDataInicio, #inputDataFim').attr('max', now);

    $('#filter').on('submit', function (event) {
        event.preventDefault();
        arrSelected = [] 
        objSelected = {}
        var log = $('#typeSelect').val();
        $("#selectedValues option").each(function() {
            if(log == 'clientes'){
                arrSelected.push($(this).val())
            } else if(log == 'tecnicos'){
                arrSelected.push($(this).val())
            }
        });
        objSelected = {'name': 'selected', 'value': arrSelected}

        switch (log) {
            // ligações
            case 'entrantes':
                dtTable.updateIncomingMontlyCalls();
                dtTable.updateIncomingWeeklyCalls();
                dtTable.updateIncomingDailyCalls();
                dtTable.updateIncomingHourlyCalls();
                $('.logs').not('#logsEntryCalls').attr('hidden', true)
                $('#logsEntryCalls').attr('hidden', false)
                break;
            case 'saintes':
                dtTable.updateOutgoingMontlyCalls();
                dtTable.updateOutgoingWeeklyCalls();
                dtTable.updateOutgoingDailyCalls();
                dtTable.updateOutgoingHourlyCalls();

                $('.logs').not('#logsOutCalls').attr('hidden', true)
                $('#logsOutCalls').attr('hidden', false)
                break; ""
            case 'transferidas':
                dtTable.updateTransferCalls();

                $('.logs').not('#logsTransferCalls').attr('hidden', true)
                $('#logsTransferCalls').attr('hidden', false)
                break;
            case 'naoAtendidas':
                dtTable.updateAbandonedCalls();

                $('.logs').not('#logsAbandonedCalls').attr('hidden', true)
                $('#logsAbandonedCalls').attr('hidden', false)
                break;

            // operadores
            case 'pausas':
                dtTable.updatePauses();

                $('.logs').not('#logsPauses').attr('hidden', true)
                $('#logsPauses').attr('hidden', false)
            break;
            case 'kpi':
                logs.kpi();
            break;
            case 'pesquisaTi':
                $('.logs').not('#logsPesquisaTi').attr('hidden', true)
                $('#logsPesquisaTi').attr('hidden', false)
                dtTable.updatePesquisaTi();
            break;
            case 'insatisfaction':
                $('.logs').not('#logsInsatisfaction').attr('hidden', true);
                $('#logsInsatisfaction').attr('hidden', false);
                dtTable.updateInsatisfaction();
            break;
            case 'products':
                $('.logs').not('#logsProducts').attr('hidden', true);
                $('#logsProducts').attr('hidden', false);
                dtTable.updateProducts();
            break;
            case 'clientes':
                $('.logs').not('#logsClients').attr('hidden', true);
                $('#logsClients').attr('hidden', false);
                dtTable.updateClientsMonth();
                dtTable.updateClientsWeek();
                dtTable.updateClientsDay();
                dtTable.updateClientsHour();
            break;
            case 'tecnicos':
                $('.logs').not('#logsTechs').attr('hidden', true);
                $('#logsTechs').attr('hidden', false);
                dtTable.updateTechsMonth();
                dtTable.updateTechsWeek();
                dtTable.updateTechsDay();
                dtTable.updateTechsHour();
            break;
        }
    })

    
    // axios.get('/user/listOperators') 
    // .then( (data) => { 
    //     operators = data.data;
    // })
    // .catch( (err) => { 
    //     console.log(err);
    // })

    // axios.get('/customer_base/getWallets')
    // .then( (data) => { 
    //     clients = data.data;
    // })
    // .catch( (err) => { 
    //     console.log(err);
    // })
    

    // element?.addEventListener('change', function(){

    //     if(element.value === 'clientes'){
    //         let select = document.getElementById('avaiableClientsOnly');
    //         let str = ``;

    //         document.getElementById('techsSelect').setAttribute('hidden', true);
    //         document.getElementById('avaiableTechsOnly').removeAttribute('required');
    //         document.getElementById('clientsSelect').removeAttribute('hidden');
    //         document.getElementById('avaiableClientsOnly').setAttribute('required', true);

    //         clients.forEach( (client) => { 
    //             str += `<option value="${client.fantasy_name}">${client.fantasy_name}</option>`;
    //         });

    //         select.innerHTML = str;
    //     } else if(element.value === 'tecnicos') {
    //         let select = document.getElementById('avaiableTechsOnly');
    //         let str = ``;

    //         document.getElementById('clientsSelect').setAttribute('hidden', true);
    //         document.getElementById('avaiableClientsOnly').removeAttribute('required');
    //         document.getElementById('techsSelect').removeAttribute('hidden');
    //         document.getElementById('avaiableTechsOnly').setAttribute('required', true);

    //         operators.forEach( (operator) => {
    //             str += `<option value="${operator.id}">${operator.name}</option>`;
    //         });
            
    //         select.innerHTML = str;

    //     } else {
    //         document.getElementById('clientsSelect').setAttribute('hidden', true);
    //         document.getElementById('avaiableClientsOnly').removeAttribute('required');
    //         document.getElementById('techsSelect').setAttribute('hidden', true);
    //         document.getElementById('avaiableTechsOnly').removeAttribute('required');
    //     }
    // });

    searchClients?.addEventListener('keyup', function(){
        let filterName = searchClients.value.toUpperCase();
        $('#avaiableClientsOnly').find('option').each( function(){
            let elementContent = $(this).text().toUpperCase();
            let matches = elementContent.indexOf(filterName) >= 0;
            $(this).css('display', matches ? 'block' : 'none');
        });
    });

    searchOperators?.addEventListener('keyup', function() {
        let filterName = searchOperators.value.toUpperCase();
        $('#avaiableTechsOnly').find('option').each(function (){
            let elementContent = $(this).text().toUpperCase();
            let matches = elementContent.indexOf(filterName) >= 0;
            $(this).css('display', matches ? 'block' : 'none');
        });
    });


    // dtTable.initAll();
    // logs.entryCalls();

    // $('#submitButton').on('click', function (event) {
    //     event.preventDefault();
    //     var log = $('#typeSelect').val();
    //     switch (log) {
    //         // ligações
    //         case 'entrantes':
    //             dtTable.updateIncomingMontlyCalls();
    //             dtTable.updateIncomingWeeklyCalls();
    //             dtTable.updateIncomingDailyCalls();
    //             dtTable.updateIncomingHourlyCalls();
    //             $('.logs').not('#logsEntryCalls').attr('hidden', true)
    //             $('#logsEntryCalls').attr('hidden', false)
    //             break;
    //         case 'saintes':
    //             dtTable.updateOutgoingMontlyCalls();
    //             dtTable.updateOutgoingWeeklyCalls();
    //             dtTable.updateOutgoingDailyCalls();
    //             dtTable.updateOutgoingHourlyCalls();

    //             $('.logs').not('#logsOutCalls').attr('hidden', true)
    //             $('#logsOutCalls').attr('hidden', false)
    //             break; ""
    //         case 'transferidas':
    //             dtTable.updateTransferCalls();

    //             $('.logs').not('#logsTransferCalls').attr('hidden', true)
    //             $('#logsTransferCalls').attr('hidden', false)
    //             break;
    //         case 'naoAtendidas':
    //             dtTable.updateAbandonedCalls();

    //             $('.logs').not('#logsAbandonedCalls').attr('hidden', true)
    //             $('#logsAbandonedCalls').attr('hidden', false)
    //             break;

    //         // operadores
    //         case 'pausas':
    //             dtTable.updatePauses();

    //             $('.logs').not('#logsPauses').attr('hidden', true)
    //             $('#logsPauses').attr('hidden', false)
    //         break;
    //         case 'kpi':
    //             logs.kpi();
    //         break;
    //         case 'pesquisaTi':
    //             $('.logs').not('#logsPesquisaTi').attr('hidden', true)
    //             $('#logsPesquisaTi').attr('hidden', false)
    //             dtTable.updatePesquisaTi();
    //         break;
    //         case 'insatisfaction':
    //             $('.logs').not('#logsInsatisfaction').attr('hidden', true);
    //             $('#logsInsatisfaction').attr('hidden', false);
    //             dtTable.updateInsatisfaction();
    //         break;
    //         case 'products':
    //             $('.logs').not('#logsProducts').attr('hidden', true);
    //             $('#logsProducts').attr('hidden', false);
    //             dtTable.updateProducts();
    //         break;
    //         case 'clientes':
    //             $('.logs').not('#logsClients').attr('hidden', true);
    //             $('#logsClients').attr('hidden', false);
    //             dtTable.updateClientsMonth();
    //             dtTable.updateClientsWeek();
    //             dtTable.updateClientsDay();
    //             dtTable.updateClientsHour();
    //         break;
    //         case 'tecnicos':
    //             $('.logs').not('#logsTechs').attr('hidden', true);
    //             $('#logsTechs').attr('hidden', false);
    //             dtTable.updateTechsMonth();
    //             dtTable.updateTechsWeek();
    //             dtTable.updateTechsDay();
    //             dtTable.updateTechsHour();
    //         break;
    //     }
    // })
})

function Charts() {
    var self = this;
    var currentChart = 'none';
    this.setCurrentChart = function (data) {
        return currentChart = data;
    }
    this.getCurrentChart = function () {
        return currentChart;
    }

    this.entryCalls = function () {
        return axios.get('/reports/graphicCall')
            .then(function (response) {
                var bigGraphic = {
                    day_week: [],
                    serie: [
                        { name: 'Recebidas', data: [] },
                        { name: 'Atendidas', data: [] },
                        { name: 'Transferidas', data: [] },
                        { name: 'Não Atendidas', data: [] },
                        { name: 'Abandonadas', data: [] },
                    ]
                }

                $.each(response.data.weekGraphic, function (index, item) {
                    bigGraphic.day_week.push(item.day);
                    bigGraphic.serie[0].data.push(item.details.recebidas)
                    bigGraphic.serie[1].data.push(item.details.atendidas)
                    bigGraphic.serie[2].data.push(item.details.trasferidas)
                    bigGraphic.serie[3].data.push(item.details.naoAtendidas)
                    bigGraphic.serie[4].data.push(item.details.abandonadas)
                })

                var graphic2 = {
                    category: [],
                    serie: []
                }

                $.each(response.data.total_month, function (index, item) {
                    graphic2.category.push(index.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); }))
                    graphic2.serie.push(item)
                })

                var graphic3 = {
                    category: [],
                    serie: []
                }

                $.each(response.data.total_day, function (index, item) {
                    graphic3.category.push(index.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); }))
                    graphic3.serie.push(item)
                })

                var html = $(`<div class="col-8">
					<chart-bar-component title="Ligações Na Semana" :categories='${JSON.stringify(bigGraphic.day_week)}' :values='${JSON.stringify(bigGraphic.serie)}'>
					</chart-bar-component>
				</div>
				<div class="col-4">
					<chart-donut-component title="Total de Ligaçoes do Mês" :categories='${JSON.stringify(graphic2.category)}' :values='${JSON.stringify(graphic2.serie)}'></chart-donut-component>
					<chart-donut-component title="Total de Ligaçoes do Dia" :categories='${JSON.stringify(graphic3.category)}' :values='${JSON.stringify(graphic3.serie)}'></chart-donut-component>				
				</div>`);
                var chartArea = $('#resultLogCharts');
                chartArea.html(html);

                new Vue({
                    render: chartArea.render,
                    staticRenderFns: chartArea.staticRenderFns
                }).$mount('#resultLogCharts')
            })
            .catch(function (error) {
                console.error(error);
            })
    }

    this.pauses = function () {
        return axios.get('reports/graphicPause')
            .then(function (response) {
                var bigGraphic = { day_week: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'], serie: [] }

                var details = []

                $.each(response.data.weekGraphic, function (index, item) {
                    bigGraphic.serie.push(item);
                })

                var graphic2 = {
                    category: [],
                    serie: []
                }

                $.each(response.data.total_month, function (index, item) {
                    if (item.name != 'Ativar') {
                        graphic2.category.push(item.name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); }))
                        // var time = moment(item.time, 'HH:mm:ss').diff(moment().startOf('day'), 'seconds')
                        graphic2.serie.push(item.quantity)
                    }
                })

                var graphic3 = {
                    category: [],
                    serie: []
                }

                $.each(response.data.total_day, function (index, item) {
                    if (item.name != 'Ativar') {
                        graphic3.category.push(item.name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); }))
                        // var time = moment(item.time, 'HH:mm:ss').diff(moment().startOf('day'), 'seconds')
                        graphic3.serie.push(item.quantity)
                    }
                })

                var html = $(`<div class="col-8">
				<chart-bar-component title="Pausas Na Semana" :categories='${JSON.stringify(bigGraphic.day_week)}' :values='${JSON.stringify(bigGraphic.serie)}'>
				</chart-bar-component>
			</div>
			<div class="col-4">
				<chart-donut-component title="Total de Pausas do Mês" :categories='${JSON.stringify(graphic2.category)}' :values='${JSON.stringify(graphic2.serie)}'></chart-donut-component>
				<chart-donut-component title="Total de Pausas do Dia" :categories='${JSON.stringify(graphic3.category)}' :values='${JSON.stringify(graphic3.serie)}'></chart-donut-component>
			</div>`);
                var chartArea = $('#resultLogCharts');
                chartArea.html(html);

                new Vue({
                    render: chartArea.render,
                    staticRenderFns: chartArea.staticRenderFns
                }).$mount('#resultLogCharts')
            })
            .catch(function (error) {
                console.error(error);
            })
    }
}

function Logs() {
    this.entryCalls = function () {
        dtTable.updateIncomingMontlyCalls();
        dtTable.updateIncomingWeeklyCalls();
        dtTable.updateIncomingDailyCalls();
        dtTable.updateIncomingHourlyCalls();
        if (charts.getCurrentChart() != 'entryCalls') {
            charts.entryCalls();
            charts.setCurrentChart('entryCalls');
        }
        $('.logs').not('#logsEntryCalls').attr('hidden', true)
        $('#logsEntryCalls').attr('hidden', false)
    }

    this.outCalls = function () {
        dtTable.updateOutgoingMontlyCalls();
        dtTable.updateOutgoingWeeklyCalls();
        dtTable.updateOutgoingDailyCalls();
        dtTable.updateOutgoingHourlyCalls();
        if (charts.getCurrentChart() != 'entryCalls') {
            charts.entryCalls();
            charts.setCurrentChart('entryCalls');
        }
        $('.logs').not('#logsOutCalls').attr('hidden', true)
        $('#logsOutCalls').attr('hidden', false)
    }

    this.transferCalls = function () {
        dtTable.updateTransferCalls();
        if (charts.getCurrentChart() != 'entryCalls') {
            charts.entryCalls();
            charts.setCurrentChart('entryCalls');
        }
        $('.logs').not('#logsTransferCalls').attr('hidden', true)
        $('#logsTransferCalls').attr('hidden', false)
    }

    this.abandonedCalls = function () {
        dtTable.updateAbandonedCalls();
        if (charts.getCurrentChart() != 'entryCalls') {
            charts.entryCalls();
            charts.setCurrentChart('entryCalls');
        }
        $('.logs').not('#logsAbandonedCalls').attr('hidden', true)
        $('#logsAbandonedCalls').attr('hidden', false)
    }

    this.pauses = function () {
        dtTable.updatePauses();
        if (charts.getCurrentChart() != 'pauses') {
            charts.pauses();
            charts.setCurrentChart('pauses');
        }
        $('.logs').not('#logsPauses').attr('hidden', true)
        $('#logsPauses').attr('hidden', false)
    }

    this.kpi = function () {
        dtTable.updateKpi();
        if (charts.getCurrentChart() != 'pauses') {
            charts.pauses();
            charts.setCurrentChart('pauses');
        }
        $('.logs').not('#logsKpi').attr('hidden', true)
        $('#logsKpi').attr('hidden', false)
    }

    this.pesquisaTi = function () {
        console.log('Só salve')
        dtTable.updatePesquisaTi();
        if (charts.getCurrentChart() != 'entryCalls') {
            chart.pauses();
            charts.setCurrentChart('entryCalls');
        }
        $('.logs').not('#logsPesquisaTi').attr('hidden', 'true')
        $('#logsPesquisaTi').attr('hidden', false)


    }
}

function DtTables() {

    var self = this;
    var incomingMontlyCalls;
    this.dtIncomingMontlyCalls = function () {

        incomingMontlyCalls = $('#incomingMontlyCalls').DataTable({
            ajax: {
                url: '/reports/receive/month',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            columns: [{
                data: "month",
                title: 'Mês'
            },
            {
                data: "receive",
                title: 'Recebidas'
            },
            {
                data: "answers",
                title: 'Total Lig. Atendidas'
            },
            {
                data: "notAnswes",
                title: 'Total Não Atendidas'
            },
            {
                data: "abandons",
                title: 'Ligações Abandonadas'
            },
            {
                data: "transfers",
                title: 'Transferidas'
            },
            {
                data: "avarage_answers",
                title: 'Média de Ligações Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_notAnswes",
                title: 'Média de Ligações Não Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_abandons",
                title: 'Média de Ligações Abandonadas',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        incomingMontlyCalls.buttons('.dtUpdateButton').remove();
    }
    this.updateIncomingMontlyCalls = function () {
        return (incomingMontlyCalls) ? incomingMontlyCalls.ajax.reload(null, false) : this.dtIncomingMontlyCalls();
    }

    var incomingWeeklyCalls;
    this.dtIncomingWeeklyCalls = function () {
        incomingWeeklyCalls = $('#incomingWeeklyCalls').DataTable({
            ajax: {
                url: '/reports/receive/week',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            columns: [{
                data: "week",
                title: 'Semana'
            },
            {
                data: "receive",
                title: 'Recebidas'
            },
            {
                data: "answers",
                title: 'Total Lig. Atendidas'
            },
            {
                data: "notAnswes",
                title: 'Total Não Atendidas'
            },
            {
                data: "abandons",
                title: 'Ligações Abandonadas'
            },
            {
                data: "transfers",
                title: 'Transferidas'
            },
            {
                data: "avarage_answers",
                title: 'Média de Ligações Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_notAnswes",
                title: 'Média de Ligações Não Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_abandons",
                title: 'Média de Ligações Abandonadas',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        incomingWeeklyCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateIncomingWeeklyCalls = function () {
        return (incomingWeeklyCalls) ? incomingWeeklyCalls.ajax.reload(null, false) : this.dtIncomingWeeklyCalls();
    }

    var incomingDailyCalls;
    this.dtIncomingDailyCalls = function () {
        incomingDailyCalls = $('#incomingDailyCalls').DataTable({
            ajax: {
                url: '/reports/receive/day',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            columns: [{
                data: 'day',
                title: 'Dia',
                render: $.fn.dataTable.render.moment('YYYY-MM-DD', 'DD/MM/YYYY')
            },
            {
                data: 'receive',
                title: 'Recebidas'
            },
            {
                data: 'answers',
                title: 'Total Lig. Atendidas'
            },
            {
                data: 'notAnswes',
                title: 'Total Não Atendidas'
            },
            {
                data: 'abandons',
                title: 'Ligações Abandonadas'
            },
            {
                data: 'transfers',
                title: 'Transferidas'
            },
            {
                data: "avarage_answers",
                title: 'Média de Ligações Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_notAnswes",
                title: 'Média de Ligações Não Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_abandons",
                title: 'Média de Ligações Abandonadas',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        incomingDailyCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateIncomingDailyCalls = function () {
        return (incomingDailyCalls) ? incomingDailyCalls.ajax.reload(null, false) : this.dtIncomingDailyCalls();
    }

    var incomingHourlyCalls;
    this.dtIncomingHourlyCalls = function () {
        incomingHourlyCalls = $('#incomingHourlyCalls').DataTable({
            ajax: {
                url: '/reports/receive/hour',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            order: [
                ['0', 'desc']
            ],
            columns: [{
                data: 'hour',
                title: 'Hora'
            },
            {
                data: 'receive',
                title: 'Recebidas'
            },
            {
                data: 'answers',
                title: 'Total Lig. Atendidas'
            },
            {
                data: 'notAnswes',
                title: 'Total Não Atendidas'
            },
            {
                data: 'abandons',
                title: 'Ligações Abandonadas'
            },
            {
                data: 'transfers',
                title: 'Transferidas'
            },
            {
                data: "avarage_answers",
                title: 'Média de Ligações Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_notAnswes",
                title: 'Média de Ligações Não Atendidas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_abandons",
                title: 'Média de Ligações Abandonadas',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        incomingHourlyCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateIncomingHourlyCalls = function () {
        return (incomingHourlyCalls) ? incomingHourlyCalls.ajax.reload(null, false) : this.dtIncomingHourlyCalls();
    }

    // outgoing calls
    var outgoingMontlyCalls;
    this.dtOutgoingMontlyCalls = function () {
        outgoingMontlyCalls = $('#outgoingMontlyCalls').DataTable({
            ajax: {
                url: '/reports/outgoing/month',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            columns: [{
                data: "month",
                title: 'Mês'
            },
            {
                data: "total",
                title: 'Total de Ligações'
            },
            {
                data: "outgoing",
                title: 'Ligações Saíntes'
            },
            {
                data: "internalCall",
                title: 'Ligações Internas'
            },
            {
                data: "avarage_internalCall",
                title: 'Média de Ligações Internas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_outgoing",
                title: 'Média de Ligações Saintes',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        outgoingMontlyCalls.buttons('.dtUpdateButton').remove();
    }
    this.updateOutgoingMontlyCalls = function () {
        return (outgoingMontlyCalls) ? outgoingMontlyCalls.ajax.reload(null, false) : this.dtOutgoingMontlyCalls();
    }

    var outgoingWeeklyCalls;
    this.dtOutgoingWeeklyCalls = function () {
        outgoingWeeklyCalls = $('#outgoingWeeklyCalls').DataTable({
            ajax: {
                url: '/reports/outgoing/week',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            columns: [{
                data: "week",
                title: 'Semana'
            },
            {
                data: "total",
                title: 'Total de Ligações'
            },
            {
                data: "outgoing",
                title: 'Ligações Saíntes'
            },
            {
                data: "internalCall",
                title: 'Ligações Internas'
            },
            {
                data: "avarage_internalCall",
                title: 'Média de Ligações Internas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_outgoing",
                title: 'Média de Ligações Saintes',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        outgoingWeeklyCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateOutgoingWeeklyCalls = function () {
        return (outgoingWeeklyCalls) ? outgoingWeeklyCalls.ajax.reload(null, false) : this.dtOutgoingWeeklyCalls();
    }

    var outgoingDailyCalls;
    this.dtOutgoingDailyCalls = function () {
        outgoingDailyCalls = $('#outgoingDailyCalls').DataTable({
            ajax: {
                url: '/reports/outgoing/day',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            columns: [{
                data: 'day',
                title: 'Dia',
                render: $.fn.dataTable.render.moment('YYYY-MM-DD', 'DD/MM/YYYY')
            },
            {
                data: "total",
                title: 'Total de Ligações'
            },
            {
                data: "outgoing",
                title: 'Ligações Saíntes'
            },
            {
                data: "internalCall",
                title: 'Ligações Internas'
            },
            {
                data: "avarage_internalCall",
                title: 'Média de Ligações Internas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_outgoing",
                title: 'Média de Ligações Saintes',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        outgoingDailyCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateOutgoingDailyCalls = function () {
        return (outgoingDailyCalls) ? outgoingDailyCalls.ajax.reload(null, false) : this.dtOutgoingDailyCalls();
    }

    var outgoingHourlyCalls;
    this.dtOutgoingHourlyCalls = function () {
        outgoingHourlyCalls = $('#outgoingHourlyCalls').DataTable({
            ajax: {
                url: '/reports/outgoing/hour',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            order: [
                ['0', 'desc']
            ],
            columns: [{
                data: 'hour',
                title: 'Hora'
            },
            {
                data: "total",
                title: 'Total de Ligações'
            },
            {
                data: "outgoing",
                title: 'Ligações Saíntes'
            },
            {
                data: "internalCall",
                title: 'Ligações Internas'
            },
            {
                data: "avarage_internalCall",
                title: 'Média de Ligações Internas',
                render: data => { return data + '%' }
            },
            {
                data: "avarage_outgoing",
                title: 'Média de Ligações Saintes',
                render: data => { return data + '%' }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        outgoingHourlyCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateOutgoingHourlyCalls = function () {
        return (outgoingHourlyCalls) ? outgoingHourlyCalls.ajax.reload(null, false) : this.dtOutgoingHourlyCalls();
    }

    // transfer calls
    var transferCalls
    this.dtTransferCalls = function () {
        transferCalls = $('#transferCalls').DataTable({
            ajax: {
                url: '/reports/transfer',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            order: [
                ['1', 'desc']
            ],
            columns: [{
                data: 'name',
                title: 'Nome',
                className: 'text-center',
            },
            {
                data: "line",
                title: 'Ramal',
                className: 'text-center',
            },
            {
                data: "time_call",
                title: 'Tempo em Ligação',
                render: function (data) { return moment.utc(data * 1000).format('HH:mm:ss') },
                className: 'text-center',
            },
            {
                data: "average_time_call",
                title: 'Tempo Médio de Ligação',
                render: function (data) { return moment.utc(data * 1000).format('HH:mm:ss') },
                className: 'text-center',
            },
            {
                data: "hold_time",
                title: 'Tempo de Espera',
                render: function (data) { return moment.utc(data * 1000).format('HH:mm:ss') },
                className: 'text-center',
            },
            {
                data: "average_hold_time",
                title: 'Tempo Médio de Espera',
                render: function (data) { return moment.utc(data * 1000).format('HH:mm:ss') },
                className: 'text-center',
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        transferCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateTransferCalls = function () {
        return (transferCalls) ? transferCalls.ajax.reload(null, false) : this.dtTransferCalls();
    }

    // abandoned calls
    var abandonedCalls
    this.dtAbandonedCalls = function () {
        abandonedCalls = $('#abandonedCalls').DataTable({
            ajax: {
                url: '/reports/abandon',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            order: [
                ['2', 'desc']
            ],
            columns: [{
                data: 'date',
                title: 'Data',
                className: 'text-center',
                render: $.fn.dataTable.render.moment('YYYY-MM-DD', 'DD/MM/YYYY')
            },
            {
                data: "number",
                title: 'Número',
                className: 'text-center'
            },
            {
                data: "time",
                title: 'Tempo até Abandono',
                className : 'text-center',
                render: function (data) { return moment.utc(data * 1000).format('HH:mm:ss') }
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        abandonedCalls.buttons('.dtUpdateButton').remove();
    }

    this.updateAbandonedCalls = function () {
        return (abandonedCalls) ? abandonedCalls.ajax.reload(null, false) : this.dtAbandonedCalls();
    }

    // abandoned calls
    var pauses
    this.dtPauses = function () {
        pauses = $('#pauses').DataTable({
            ajax: {
                url: '/reports/pause',
                dataType: 'json',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                type: 'get',
                dataSrc: ''
            },
            order: [
                ['0', 'asc']
            ],
            columns: [{
                data: 'name',
                title: 'Nome',
                className: 'text-center',
            },
            {
                data: "line",
                title: 'Ramal',
                className: 'text-center',
            },
            {
                data: null,
                defaultContent: "<button type='button' class='btn btn-sm btn-primary viewMore'><i class='fas fa-search-plus fa-fw'></i></button>",
                title: 'Ver Detalhes',
                className: 'text-center'
            }
            ],
            footerCall: function (tfoot, data, start, end, display) {
                console.log(display);
            }
        });

        $('#pauses').on('click', 'td > button.viewMore', function (event) {
            var tr = $(this).closest('tr');
            var row = pauses.row(tr);
            var data = row.data();

            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.id)
                row.child(html).show();

                var dt = $('#dt_' + data.id).DataTable({
                    data: data.types,
                    columns: [
                        { data: 'type_name', title: 'Pausa' },
                        { data: 'general', title: 'Quantidade' },
                        { data: 'total_time', title: 'Tempo Total' },
                        { data: 'avarage_time', title: 'Tempo Médio' },
                        { data: null, defaultContent: "<button type='button' class='btn btn-sm btn-primary viewMoreChild'><i class='fas fa-search-plus fa-fw'></i></button>", title: 'Ver Detalhes', className: 'text-center' }
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');

                $('#dt_' + data.id).on('click', 'td > button.viewMoreChild', function (event) {
                    var tr = $(this).closest('tr');
                    var row = dt.row(tr);
                    var data = row.data();

                    $('#modalTable').DataTable({
                        data: data.detail,
                        columns: [
                            { data: 'date', title: 'Data / Hora', render: $.fn.dataTable.render.moment('YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY - HH:mm:ss') },
                            { data: 'name', title: 'Tipo' }
                        ]
                    }).buttons('.dtUpdateButton').remove();

                    $('#reportsModal').modal('show');
                })
            }
        })

        $('#reportsModal').on('hide.bs.modal', function (event) {
            $('#modalTable').DataTable().destroy();
        })

        pauses.buttons('.dtUpdateButton').remove();
    }

    this.format = function (id) {
        if (id == null) {
            return console.error('[DtTables -> format()]: invalid id:', id)
        }

        var html = `
		<table id="dt_${id}" class="table display table-hover table-striped" style="width: 100%">
			<thead>
			</thead>
			<tbody>
			</tbody>
			<tfoot>
			</tfoot>
		</table>
		`;

        return html
    }

    this.updatePauses = function () {
        return (pauses) ? pauses.ajax.reload(null, false): this.dtPauses();
    }

    var kpi;
    this.dtKpi = function () {
        kpi = $('#kpi').DataTable({
            ajax: {
                url: '/reports/kpi',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                dataSrc: ''
            },
            columns: [
                { data: 'date', title: 'Data', render: $.fn.dataTable.render.moment('YYYY-MM-DD', 'DD/MM/YYYY'), className: 'text-center' },
                { data: 'directedToAttedance', title: 'Direcionadas ao Atendimento',className: 'text-center', },
                { data: 'attedance', title: 'Atendimento' },
                { data: 'capacityAttedance', title: 'Capacidade de Atendimento', render: data => data + '%',className: 'text-center', },
                { data: 'tme', title: 'TME', render: data => moment.utc(data * 1000).format('HH:mm:ss'),className: 'text-center', },
                { data: 'tma', title: 'TMA', render: data => moment.utc(data * 1000).format('HH:mm:ss'),className: 'text-center', },
                { data: 'abandonQueue', title: 'Abandonos na Fila',className: 'text-center', },
                { data: 'percentageAbandon', title: 'Porcentagem de Abandono', render: data => data + '%',className: 'text-center', },
                { data: 'qlp', title: 'QLP',className: 'text-center', }
            ]
        }).buttons('.dtUpdateButton').remove()
    }

    this.updateKpi = function () {
        return kpi.ajax.reload(null, false);
    }


    var pesquisaTi;
    this.getPesquisaTi = function () {
        return pesquisaTi
    };

    this.dtPesquisaTi = function () {
        pesquisaTi = $('#pesquisaTi').DataTable({
            ajax: {
                url: '/reports/pesquisa_log',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray()
                    return data;
                },
                dataSrc: ''
            },
            columns: [
                {
                    data: 'created_at',
                    title: 'Data',
                    render: $.fn.dataTable.render.moment('YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss'),
                    className: 'text-center'
                },
                {
                    data: 'tel',
                    title: 'Telefone',
                    className: 'text-center'
                },
                {
                    data: 'ramal',
                    title: 'Ramal',
                    className: 'text-center',
                    render: data => data.replace(/(.+?)\//, '')
                },
                {
                    data: 'nota_nome',
                    title: 'Nota',
                    className: 'text-center',
                    render: (data, type, row, meta) => {
                        var html = `<span style="color: grey; font-weight: bold">Não avaliou</span>`;

                        console.log(row.nota == 4);

                        if (row.nota == 1) {
                            html = `<span style="color: #BB0404; font-weight: bold">Muito Insatisfeito</span>`
                            // 
                        }
                        if (row.nota == 2) {
                            html = `<span style="color: #E30000 ; font-weight: bold">Insatisfeito</span>`
                        }
                        if (row.nota == 3) {
                            html = `<span style="color: #FFA200; font-weight: bold">Regular</span>`
                        }
                        if (row.nota == 4) {
                            html = `<span style="color: #16DD3A; font-weight:bold">Satisfeito</span>`
                        }
                        // 
                        if (row.nota == 5) {
                            html = `<span style="color: #02921D; font-weight: bold">Muito Satisfeito</span>`
                        }

                        return html;
                    }

                },
                {
                    data: 'reason',
                    title: 'Razão',
                    className: 'text-center'
                },
                {
                    data: 'products[0].product_name.description',
                    title: 'Produtos',
                    className: 'text-center',
                }
            ]
        }).buttons('.dtUpdateButton').remove()


    };

    this.updatePesquisaTi = function () {
        return (pesquisaTi) ? pesquisaTi.ajax.reload(null, false) : this.dtPesquisaTi();
    };

    var insatisfaction;
    this.dtInsatisfaction = function () {
        insatisfaction = $('#insatisfaction').DataTable({
            ajax: {
                url: '/reports/reason_survery',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    return data;
                },
                dataSrc: ''
            },
            columns: [
                {
                    data: 'user_name',
                    title: 'Operador',
                    className: 'text-center'
                },
                {
                    data: 'ramal',
                    title: 'Ramal',
                    className: 'text-center'
                },
                {
                    data: "reason",
                    title: "Razão",
                    className: 'text-center'
                },
                {
                    data: "qtd",
                    title: "Quantidade",
                    className: 'text-center'
                }
            ]
        }).buttons('dtUpdateButton').remove();
    };

    this.updateInsatisfaction = function () {
        return (insatisfaction) ? insatisfaction.ajax.reload(null, false) : this.dtInsatisfaction();
    };

    var products;
    this.dtProducts = function () {
        products = $('#products').DataTable({
            ajax: {
                url: '/reports/product_survery',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "code",
                    title: "Código",
                    className: "text-center"
                },
                {
                    data: "description",
                    title: "Descrição",
                    className: "text-center"
                },
                {
                    data: "nota",
                    title: "Nota",
                    className: "text-center",
                    render: (data, type, row, meta) => {
                        var html = `<span style="color: grey; font-weight: bold">Não avaliou</span>`;

                        if (row.nota == "Muito Satisfeito") {
                            html = `<span style="color: #02921D; font-weight: bold">Muito Satisfeito</span>`
                            // 
                        }
                        if (row.nota == "Satisfeito") {
                            html = `<span style="color: #16DD3A; font-weight:bold">Satisfeito</span>`
                        }
                        if (row.nota == "Regular") {
                            html = `<span style="color: #FFA200; font-weight: bold">Regular</span>`
                        }
                        if (row.nota == "Insatisfeito") {
                            html = `<span style="color: #E30000 ; font-weight: bold">Insatisfeito</span>`
                        }
                        // 
                        if (row.nota == "Muito Insatisfeito") {
                            html = `<span style="color: #BB0404; font-weight: bold">Muito Insatisfeito</span>`
                        }

                        return html;
                    }
                },
                {
                    data: "qtd",
                    title: "Quantidade",
                    className: "text-center"
                },
            ]
        }).buttons('dtUpdateButton').remove();
    };

    this.updateProducts = function () {
        return (products) ? products.ajax.reload(null, false) : this.dtProducts();
    }

    var clientsMonth;
    this.dtClientsMonth = function(){
        clientsMonth = $('#clientsMonth').DataTable({
            ajax: {
                url: '/reports/listCalls/month',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "date",
                    title: "Mês",
                    className: "text-center"
                },
                {
                    data: "client",
                    title: "Cliente",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#clientsMonth').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = clientsMonth.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
        
    };

    this.updateClientsMonth = function(){
        return (clientsMonth) ? clientsMonth.ajax.reload(null, false) : this.dtClientsMonth();
    }

    var techsMonth;
    this.dtTechsMonth = function(){
        techsMonth = $('#techsMonth').DataTable({
            ajax: {
                url: '/reports/listOcurrencesTech/month',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "day",
                    title: "Mês",
                    className: "text-center"
                },
                {
                    data: "tech",
                    title: "Técnicos",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#techsMonth').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = techsMonth.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateTechsMonth = function(){
        return (techsMonth) ? techsMonth.ajax.reload(null, false) : this.dtTechsMonth();
    }

    var techsWeek;
    this.dtTechsWeek = function(){
        techsWeek = $('#techsWeek').DataTable({
            ajax: {
                url: '/reports/listOcurrencesTech/week',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "day",
                    title: "Semana",
                    className: "text-center"
                },
                {
                    data: "tech",
                    title: "Técnicos",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#techsWeek').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = techsMonth.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateTechsWeek = function(){
        return (techsWeek) ? techsWeek.ajax.reload(null, false) : this.dtTechsWeek();
    }

    var techsDay;
    this.dtTechsDay = function(){
        techsDay = $('#techsDay').DataTable({
            ajax: {
                url: '/reports/listOcurrencesTech/day',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "day",
                    title: "Semana",
                    className: "text-center"
                },
                {
                    data: "tech",
                    title: "Técnicos",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#techsDay').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = techsMonth.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateTechsDay = function(){
        return (techsDay) ? techsDay.ajax.reload(null, false) : this.dtTechsDay();
    }

    var techsHour;
    this.dtTechsHour = function(){
        techsHour = $('#techsHour').DataTable({
            ajax: {
                url: '/reports/listOcurrencesTech/hour',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "day",
                    title: "Semana",
                    className: "text-center"
                },
                {
                    data: "tech",
                    title: "Técnicos",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#techsHour').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = techsMonth.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateTechsHour = function(){
        return (techsHour) ? techsHour.ajax.reload(null, false) : this.dtTechsHour();
    }

    var clientsWeek;
    this.dtClientsWeek = function(){
        clientsWeek = $('#clientsWeek').DataTable({
            ajax: {
                url: '/reports/listCalls/week',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "date",
                    title: "Semana",
                    className: "text-center"
                },
                {
                    data: "client",
                    title: "Cliente",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#clientsWeek').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = clientsWeek.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateClientsWeek = function(){
        return (clientsWeek) ? clientsWeek.ajax.reload(null, false) : this.dtClientsWeek();
    }

    var clientsDay;
    this.dtClientsDay = function(){
        clientsDay = $('#clientsDay').DataTable({
            ajax: {
                url: '/reports/listCalls/day',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "date",
                    title: "Dia",
                    className: "text-center"
                },
                {
                    data: "client",
                    title: "Cliente",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#clientsDay').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = clientsDay.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateClientsDay = function(){
        return (clientsDay) ? clientsDay.ajax.reload(null, false) : this.dtClientsDay();
    }

    var clientsHour;
    this.dtClientsHour = function(){
        clientsHour = $('#clientsHour').DataTable({
            ajax: {
                url: '/reports/listCalls/hour',
                dataType: 'json',
                type: 'get',
                data: () => {
                    var data = $('#filter').serializeArray();
                    data.push(objSelected)
                    return data;
                },
                dataSrc: ''
            },

            columns: [
                {
                    data: "date",
                    title: "Hora",
                    className: "text-center"
                },
                {
                    data: "client",
                    title: "Cliente",
                    className: "text-center"
                },
                {
                    data: "total_calls",
                    title: "Chamados Abertos",
                    className: "text-center",
                },
                {
                    data: "ongoing_calls",
                    title: "Chamados em Andamento",
                    className: "text-center"
                },
                {
                    data: "completed_calls",
                    title: "Chamados Finalizados",
                    classname: "text-center"
                },
                {
                    data: "service_time",
                    title: "Tempo Total de Atendimento",
                    className: "text-center",
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'average_service_time', 
                    title: 'Tempo Médio de Atendimento', 
                    className: 'text-center',
                    render: (data) => {
                        return data ? moment.duration(data, "seconds").format("M[ Mês] d[ dias] [<br>] h[ h] m[ min]").replace(',', '.') : "-"
                    }
                },
                {
                    data: 'percentage_completed_calls',
                    title: 'Porcentagem Chamados Finalizados',
                    className: 'text-center'
                },
                { 
                    data: 'expired_sla',
                    title: 'SLA Expirado',
                    className: 'text-center',
                    render: (data) => {
                        return data > 0 ? `<span style='color: red'>${data}</span>` : data
                    }
                },
                {
                    data: 'details',
                    title: 'Ver Mais',
                    className: 'text-center',
                    render: () => {
                        return `<button type='button' class='btn btn-outline-primary btn-sm btn-block viewMore' data-report='details' data-tab='table-in-monthly' ><i class='fa fa-eye'></i></button>`
                    }
                },
                { 
                    data: 'service_time', 
                    title: 'Tempo Atendimento(Oculta)', 
                    'visible': false 
                },
                { 
                    data: 'average_service_time', 
                    title: 'Tempo Medio(Oculta)', 
                    'visible': false 
                }
            ]
        }).buttons('dtUpdateButton').remove();

        $('#clientsHour').on('click', 'td > button.viewMore', function(event) {
            var tr = $(this).closest('tr');
            var row = clientsHour.row(tr);
            var data = row.data();
            
            if (row.child.isShown()) {
                row.child.hide();
                $('#dt_' + data.id).DataTable().destroy();
                tr.removeClass('shown');
            } else {
                var html = self.format(data.details[0].protocol)
                row.child(html).show();

                var dt = $('#dt_' + data.details[0].protocol).DataTable({
                    data: data.details,
                    columns: [
                        { data: 'created_at', title:'Data'},
                        { data: 'protocol', title: 'Protocolo' },
                        { data: 'call_type', title: 'Tipo do Chamado' },
                        { data: 'responsible', title: 'Responsáveis' },
                        { data: 'department', title: 'Departamento' },
                        { data: 'sla', title: 'SLA' },
                        { data: 'status', title: 'Status' },
                    ]
                }).buttons('.dtUpdateButton').remove()
                tr.addClass('shown');
            }

        });
    };

    this.updateClientsHour = function(){
        return (clientsHour) ? clientsHour.ajax.reload(null, false) : this.dtClientsHour();
    }

    // initiate all datatables
    this.initAll = function () {
        // incoming calls
        this.dtIncomingMontlyCalls();
        this.dtIncomingWeeklyCalls();
        this.dtIncomingDailyCalls();
        this.dtIncomingHourlyCalls();

        // outgoing calls
        this.dtOutgoingMontlyCalls();
        this.dtOutgoingWeeklyCalls();
        this.dtOutgoingDailyCalls();
        this.dtOutgoingHourlyCalls();

        // transfer calls
        this.dtTransferCalls();

        // not answered calls
        this.dtAbandonedCalls();

        // pauses
        this.dtPauses();

        // KPI
        this.dtKpi();

        //Pesquisa
        this.dtPesquisaTi();

        //Clientes
        this.dtClientsMonth();
        this.dtClientsWeek();
        this.dtClientsDay();
        this.dtClientsHour();

        //Tecnicos
        this.dtTechsMonth();
        this.dtTechsWeek();
        this.dtTechsDay();
        this.dtTechsHour();

        logs.entryCalls();
    }

    this.populateSelect = function(type){
        console.log(type);
    }
}


